import { FETCH_VOICES_SUCCESS, SET_DRILLDOWN_LEVEL, SET_IS_CURSOR_AT_START, SET_FULLSCREEN, SET_USER_ACTIVE_IN_EDITOR } from '.'

const voiceReducer = (state, action) => {
  switch (action.type) {
    case FETCH_VOICES_SUCCESS:
      return {
        ...state,
        voices: action.payload.length > 0
          ? action.payload
          : state.voices
      }

    default:
      return state
  }
}

const drildownReducer = (state, action) => {
  switch (action.type) {
    case SET_DRILLDOWN_LEVEL:
      return {
        ...state,
        editor: {
          ...state.editor,
          drilldownLevel: action.payload
        }
      }
    default:
      return state
  }
}

const editorReducer = (state, action) => {
  switch (action.type) {
    case SET_USER_ACTIVE_IN_EDITOR:
      return {
        ...state,
        editor: {
          ...state.editor,
          isUserActiveInEditor: action.payload
        }
      }

    case SET_IS_CURSOR_AT_START:
      return {
        ...state,
        editor: {
          ...state.editor,
          isCursorAtStart: action.payload
        }
      }

    case SET_FULLSCREEN:
      return {
        ...state,
        editor: {
          ...state.editor,
          isFullscreen: action.payload
        }
      }

    default:
      return state
  }
}

export { voiceReducer, drildownReducer, editorReducer }
